import api from './api';

// --- Leads Users ---
export const getLeadsUsers = () => api.get('leads/users');

// --- Lead Closing Requests ---
export const createClosingRequest = (payload: any) => api.post('closings/request', payload);
export const getClosingApprovals = () => api.get('closings/approvals');
export const approveClosingRequest = (id: string, payload: { sp_document: string }) => api.post(`closings/${id}/approve`, payload);
export const rejectClosingRequest = (id: string, payload: { rejection_reason: string }) => api.post(`closings/${id}/reject`, payload);

// --- File Upload Helper for Closing Documents (SP PDF) ---
export const uploadSpDocument = async (file: File): Promise<string> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('path', 'sp_documents');
  const response = await api.post('upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data?.data?.url as string;
};
